import { useEffect, useState } from "react";
import QRCode from "qrcode";

/** Renders `url` as a QR code data URL, so multiple panels can share one generator. */
const useBookingQrCode = (url) => {
    const [qrDataUrl, setQrDataUrl] = useState("");

    useEffect(() => {
        if (!url) {
            setQrDataUrl("");
            return undefined;
        }

        let cancelled = false;

        QRCode.toDataURL(url, {
            width: 240,
            margin: 1,
            color: { dark: "#111111", light: "#FFFFFF" },
        })
            .then((dataUrl) => {
                if (!cancelled) setQrDataUrl(dataUrl);
            })
            .catch(() => {
                if (!cancelled) setQrDataUrl("");
            });

        return () => {
            cancelled = true;
        };
    }, [url]);

    return qrDataUrl;
};

export default useBookingQrCode;
